export default {
  'auth.resetPassword.title': 'Reset Password',
  'auth.resetPassword.enterNewPass': 'Enter New Password',
  'auth.resetPassword.enterNewPass.displayText':
    'Define a new password for the user "{ value }"',
  'auth.resetPassword.successReset': 'Password reset succesfully!',
  'auth.resetPassword.button': 'Reset Password',
  'auth.resetPassword.passHasChanged': 'Your Password has been changed!',
  'auth.resetPassword.loginWithNewPass':
    'Now you can login to your account with new password',
  'auth.resetPassword.checkSpamOrBulk':
    'Check spam or bulk folders for message comming from { value }',
  'auth.resetPassword.isAssociatedAccount':
    'If { value } is associated with an aeroSUITE account, you should receive an email with instructions on how to create a new password',
  'auth.requestResetPassword.canNotAccessAccount': "Can't access your Account?",
  'auth.requestResetPassword.enterEmailAddressText':
    "Enter your email address and we'll send you a link to reset your Password",
  'auth.requestResetPassword.enterUsernameText':
    "Enter your { value } and we'll send you a link to reset your Password",
  'auth.requestResetPassword.title': 'Forgot your password?',
  'auth.requestResetPassword.checkEmail': 'Check your email',
  'auth.requestResetPassword.emailIdNotExists':
    'Please enter a valid email address',
  'auth.accountDisabled.title':
    'Oops! Your account is disabled. Please contact your administrator to regain access to your account.',
  'auth.accountDisabled.backLink': 'Go back to Sign in',
  'auth.accountDisabled.accountHasDisabled':
    'It seems your account, { value } has been disabled by the administrator',
  'auth.accountDisabled.pleaseContact':
    'Please contact { value } for further instructions to regain access to your account',

  'auth.firstTimeLogin.pageTitle': 'Activate AccelAero Account',
  'auth.firstTimeLogin.successMessage':
    'Account activated! You can now login using your new password',
  'auth.firstTimeLogin.setNewPassToActivate':
    'Set a New Password to Activate Account',
  'auth.firstTimeLogin.setPassForAccount': 'Set a Password for your Account',
  'auth.firstTimeLogin.getStarted': 'Enter your email address to get started',

  'auth.login.signInUsing': 'Sign in using',
  'auth.login.microsoft365': 'Microsoft 365',
  'auth.login.google': 'Google',
  'auth.login.title': 'Login to AccelAero',
  'auth.login.screenTitle': 'Sign in',
  'auth.login.screenTitle2': 'Sign in using aeroSUITE Credentials',
  'auth.login.signInUsing365': 'Sign in using Microsoft 365',
  'auth.login.otherSignInOptions': 'Other Sign in Options',
  'auth.login.signInUsing365MsjOrGoogle':
    'You can sign in to aeroSUITE using your Microsoft 365 or Google email and password. The following buttons will redirect you to the respective login page.',
  'auth.login.usernameInputLabel': 'Username or Email Address',
  'auth.login.emptyEmailMsg': 'Enter your username',
  'auth.login.usernamePlaceholder': 'Username or Email',
  'auth.login.emptyPassMsg': 'Enter your password',
  'auth.login.resetLink': "Can't access to your account?",
  'auth.changeExpiredPassword.setNewPassword': 'Enter New Password',
  'auth.activateAccount.alreadyActivated':
    'Seems you have already activated your account. You can now sign in using your email/username and password.',
  'auth.activateAccount.alreadyActivatedTitle':
    'You have already activated aeroSuite',
  'auth.activateAccount.contactSupportMsj':
    'Please contact { value } if you require any support.',
  'auth.activateAccount.linkExpiredTitle': 'Invitation Link Expired',
  'auth.activateAccount.linkExpiredMessage':
    'Invitation link has expired. Please request a new one from your administrator.',
  'auth.activateAccount.linkExpiredContactSupportMsj':
    'Contact { value } for further instructions.'
};
